<div class="right-side  silk-card mb-4">
  <h4>{{'Notifications settings' | translate}} {{medicalCenterName ? '- ' + medicalCenterName : ''}} </h4>
  <ngb-tabset [destroyOnHide]="false" *ngIf="notificationSettings">
    <ngb-tab title="{{'Cardiac alerts' | translate}}" id="CARDIAC">
      <ng-template ngbTabContent>
        <app-tree-settings 
          [userGlobalSettings]="getUserGlobalSettings('CARDIAC')"
          [userSettings]="notificationSettings.UrgentAlertTemplateSetting"
          [globalNode]="treeControlGlobal.dataNodes[0]"
          [dataSource]="dataSourceCardiac" [treeControl]="treeControlCardiac"
          [checklistSelection]="checklistSelection" [checklistSoundSelection]="checklistSoundSelection"
          [checklistVibrationSelection]="checklistVibrationSelection"></app-tree-settings>
      </ng-template>
    </ngb-tab>
    <ngb-tab title="{{'Technical alerts' | translate}}" id="TECH">
      <ng-template ngbTabContent>
        <app-tree-settings
          [userGlobalSettings]="getUserGlobalSettings('TECH')"
          [userSettings]="notificationSettings.UrgentAlertTemplateSetting"
          [globalNode]="treeControlGlobal.dataNodes[1]"
          [dataSource]="dataSourceTech" [treeControl]="treeControlTech"
          [checklistSelection]="checklistSelection" [checklistSoundSelection]="checklistSoundSelection"
          [checklistVibrationSelection]="checklistVibrationSelection"></app-tree-settings>
      </ng-template>
    </ngb-tab>
    <ngb-tab title="{{'NEWS alerts' | translate}}" id="NEWS">
      <ng-template ngbTabContent>
        <app-tree-settings 
          [userGlobalSettings]="getUserGlobalSettings('NEWS')"
          [userSettings]="notificationSettings.UrgentAlertTemplateSetting"
          [globalNode]="treeControlGlobal.dataNodes[2]"
          [dataSource]="dataSourceNews" [treeControl]="treeControlNews"
          [checklistSelection]="checklistSelection" [checklistSoundSelection]="checklistSoundSelection"
          [checklistVibrationSelection]="checklistVibrationSelection"></app-tree-settings>
      </ng-template>
    </ngb-tab>
    <ngb-tab title="{{'Automatic alerts' | translate}}" id="AUTOMATIC">
      <ng-template ngbTabContent>
        <app-tree-settings
          [userGlobalSettings]="getUserGlobalSettings('AUTOMATIC')"
          [userSettings]="notificationSettings.NewsAnnotationSetting"
          [globalNode]="treeControlGlobal.dataNodes[3]"
          [dataSource]="dataSourceAutomatic" [treeControl]="treeControlAutomatic"
          [checklistSelection]="checklistSelection" [checklistSoundSelection]="checklistSoundSelection"
          [checklistVibrationSelection]="checklistVibrationSelection"></app-tree-settings>
      </ng-template>
    </ngb-tab>
  </ngb-tabset>
  <div class="modal-footer d-block p-0">
    <button type="submit" (click)="submit()" class="btn note-edit" translate>
      Save
    </button>
  </div>
</div>


<div class="notification-settings">
  <!-- <div class="row">

    <div class="col-6 notification-type-col">
      <label translate>Technical alerts</label>
      <mat-tree [dataSource]="dataSourceTech" [treeControl]="treeControlTech">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
          <button mat-icon-button disabled></button>
          <mat-checkbox class="checklist-leaf-node" [checked]="checklistSelection.isSelected(node)"
            (change)="checklistSelection.toggle(node);">{{node.item}}</mat-checkbox>
        </mat-tree-node>

        <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
          <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.filename">
            <mat-icon class="mat-icon-rtl-mirror">
              {{treeControlTech.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
          </button>
          <mat-checkbox [checked]="descendantsAllSelected(node)" [indeterminate]="descendantsPartiallySelected(node)"
            (change)="todoItemSelectionToggle(node)">{{node.item}}</mat-checkbox>
        </mat-tree-node>
      </mat-tree>
    </div>
  </div>
  <div class="row">
    <div class="col-6 notification-type-col">
      <label translate>NEWS alerts</label>
      <mat-tree [dataSource]="dataSourceNews" [treeControl]="treeControlNews">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
          <button mat-icon-button disabled></button>
          <mat-checkbox class="checklist-leaf-node" [checked]="checklistSelection.isSelected(node)"
            (change)="checklistSelection.toggle(node);">{{node.item}}</mat-checkbox>
        </mat-tree-node>

        <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
          <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.filename">
            <mat-icon class="mat-icon-rtl-mirror">
              {{treeControlNews.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
          </button>
          <mat-checkbox [checked]="descendantsAllSelected(node)" [indeterminate]="descendantsPartiallySelected(node)"
            (change)="todoItemSelectionToggle(node)">{{node.item}}</mat-checkbox>
        </mat-tree-node>
      </mat-tree>
    </div>
    <div class="col-6 notification-type-col">
      <label translate>Automatic notifications</label>
      <mat-tree [dataSource]="dataSourceAutomatic" [treeControl]="treeControlAutomatic">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
          <button mat-icon-button disabled></button>
          <mat-checkbox class="checklist-leaf-node" [checked]="checklistSelection.isSelected(node)"
            (change)="checklistSelection.toggle(node);">{{node.item}}</mat-checkbox>
        </mat-tree-node>

        <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
          <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.filename">
            <mat-icon class="mat-icon-rtl-mirror">
              {{treeControlAutomatic.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
          </button>
          <mat-checkbox [checked]="descendantsAllSelected(node)" [indeterminate]="descendantsPartiallySelected(node)"
            (change)="todoItemSelectionToggle(node)">{{node.item}}</mat-checkbox>
        </mat-tree-node>
      </mat-tree>
    </div>
  </div> -->

</div>